const phaseToArray = (phase) => {
  if (!phase) {
    return []
  }
  if (Array.isArray(phase)) {
    return phase
  }
  return [phase]
}

// Resolves the rollout phase label(s) for an export row. customPhase is stored
// as an array of phase uuids; an empty array is truthy so it must be
// length-checked, not truthiness-checked, otherwise rows without a custom phase
// never fall through to the regular fase.
const getRolloutPhase = (entry, phases) => {
  if (!entry.prio) return null

  const customPhases = phaseToArray(entry.prio.customPhase)
  if (customPhases.length) {
    return customPhases
      .map(uuid => phases.find(phase => phase.uuid === uuid)?.label)
      .filter(Boolean)
      .join(', ')
  }

  return entry.prio.fase
}

const phaseLabelByUuid = (phases, uuid) => {
  if (!phases) {
    return uuid
  }
  const phase = phases.find(phase => phase.uuid === uuid)
  if (!phase) {
    return uuid
  }
  return phase.label
}

module.exports = {
  phaseToArray,
  phaseLabelByUuid,
  getRolloutPhase,
}
